export default [
    {
      path: '/admin/spare-part-replacements',
      name: 'spare-part-replacement',
      meta: { requiresAuth: true },
      component: () => import('@/pages/wholesale/replacement/index.vue')
    },
    {
      path: '/admin/spare-part-replacements/create',
      name: 'spare-part-replacement-create',
      meta: { requiresAuth: true },
      component: () => import('@/pages/wholesale/replacement/create.vue')
    },
    {
      path: '/admin/spare-part-replacements/:id/edit',
      name: 'spare-part-replacement-edit',
      meta: { requiresAuth: true },
      component: () => import('@/pages/wholesale/replacement/edit.vue')
    }
  ]
  